import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TableCellWidget", {
  title: "Table Cell",
});
